import { Component } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ArticlesService } from 'src/app/services/articles/articles.service';

import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';
import { ImageService } from 'src/app/services/image/image.service';

@Component({
  selector: 'app-artical',
  templateUrl: './artical.component.html',
  styleUrls: ['./artical.component.css'],
})
export class ArticalComponent {
  articles: any[] = [];
  constructor(
    private content: ArticlesService,
    private translate: TranslateService,
    private imageService: ImageService
  ) {}
  ngOnInit(): void {
    this.loadContent(this.translate.currentLang);

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadContent(event.lang);
    });
  }

  loadContent(currentLang: string): void {
    const langMap: Record<string, string> = {
      en: 'english',
      ar: 'arabic',
    };

    const mappedLang = langMap[currentLang] || 'english';
    this.content.getAllArticlesTranslation().subscribe({
      next: (data: any) => {
        this.articles = data?.filter(
          (item: any) => item.language === mappedLang
        );
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  getFullImageUrl(relativeUrl: string): string {
    return this.imageService.getImagePath(relativeUrl);
  }
}
